export enum DialogType {
  MODAL_NOTIFICATION_DIALOG,
  LIMIT_CONFIRMATION_DIALOG,
  PUSH_PERMISSION_DIALOG,
}

export enum NotificationTypes {
  MODAL = 'modal',
  BANNER = 'topbanner',
}
